/**
 * Created by why on 2019/7/16.
 */
import axios from '@/libs/api.request'
export const userList = (param) => {
  return axios.request({
    url: '/user/getUserPage',
    params: param,
    method: 'get'
  })
}

export const getUserDisable = (data) => {
  return axios.request({
    url: '/user/disable',
    params: data,
    method: 'get'
  })
}

export const editUser = (data) => {
  return axios.request({
    url: '/user/update',
    data: data,
    method: 'post'
  })
}

export const deleteUser = (data) => {
  return axios.request({
    url: '/user/delete',
    data: data,
    method: 'post'
  })
}

export const deleteByUser = (data) => {
  return axios.request({
    url: '/user/deleteUser',
    data: data,
    method: 'post'
  })
}

export const saveUser = (data) => {
  return axios.request({
    url: '/user/save',
    data: data,
    method: 'post'
  })
}

export const modifyEmail = (data) => {
  return axios.request({
    url: '/user/modifyEmail',
    data: data,
    method: 'post'
  })
}

export const updateOwn = (data) => {
  return axios.request({
    url: '/user/updateOwn',
    data: data,
    method: 'post'
  })
}

export const modifyPass = (data) => {
  return axios.request({
    url: '/user/modifyPass',
    data: data,
    method: 'post'
  })
}

export const getUserById = () => {
  return axios.request({
    url: '/user/findUserById',
    method: 'get'
  })
}

export const qqLogin = () => {
  return axios.request({
    url: '/qq/oauth',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/user-manage.js